import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import VendorListResults from 'components/Vendors/VendorListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  vendors: state.vendors,
  idGen: state.idGen
});

const VendorList = (props) => (
  <>
    <Helmet>
      <title>Vendors | Duot One</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <VendorListResults
          activeUserId={props.activeUserId}
          vendors={props.vendors}
          idGen={props.idGen}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (VendorList);
